<style lang="scss"></style>
<style lang="scss" scoped="scoped"></style>

<template>

  <div ref="container"
       style="overflow: auto;height: 100%;position: relative;padding: 20px;display: flex;justify-content: space-between;"
       :style="{ background:  $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#1D1D24' : '#000466' }">
    <div
        style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;"
        :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 20px;">{{$t("shebeidaichuli")}}:</span><span
        style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 24px;">{{count1}}</span>
    </div>
    <div
        style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;margin-left: 20px;"
        :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 20px;">{{
          $t("shebeiweixiuzhong")
        }}:</span><span style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 24px;">{{count2}}</span>
    </div>
  </div>

</template>
<script type="text/javascript">
export default {
  name: "web_monitor_machine_model_machine_count",
  components: {},
  watch: {
    "$attrs.orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    },
  },
  data() {
    return {
      timer: null,
      count1: 0,
      count2: 0,
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs)
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get("/web/report/page/board_repair_bill?status=1&pageSize=999", {
        params: {
          //orgId: this.$attrs.orgId,
        },
      });
      this.count1 = response.data.rows.length;

      let response2 = await this.http.get("/web/report/page/board_repair_bill?status=2&pageSize=999", {
        params: {
          //orgId: this.$attrs.orgId,
        },
      });
      this.count2 = response2.data.rows.length;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
      }, 800);
    },
  },
};
</script>
